/**
 * INFINITY LIFE 2.0 — PWA Installation Manager & Service Worker Registration
 */

import { store } from './state.js';
import { syncOfflineQueue, showToast } from './api.js';

let deferredPrompt = null;

export function initPWA() {
  // 1. Register Service Worker
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js')
        .then((reg) => {
          console.log('[PWA] Service Worker registrado com escopo:', reg.scope);

          // Check for worker updates
          reg.onupdatefound = () => {
            const installingWorker = reg.installing;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
                showToast('Nova versão disponível! Recarregue a página para atualizar.', 'info', 6000);
              }
            };
          };
        })
        .catch((err) => {
          console.warn('[PWA] Falha ao registrar Service Worker:', err);
        });
    });
  }

  // 2. Intercept beforeinstallprompt
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    store.set({
      pwaPromptEvent: e,
      isPwaInstallable: true,
    });
    console.log('[PWA] Aplicativo pronto para instalação');
  });

  // 3. App installed event
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    store.set({ isPwaInstallable: false });
    showToast('Infinity Life instalado com sucesso!', 'success');
  });

  // 4. Online / Offline listeners
  window.addEventListener('online', () => {
    store.set({ isOnline: true });
    showToast('Conexão restabelecida. Sincronizando dados...', 'success');
    syncOfflineQueue();
  });

  window.addEventListener('offline', () => {
    store.set({ isOnline: false });
    showToast('Você está offline. Operando em modo local seguro.', 'info');
  });
}

/**
 * Trigger Installation Flow
 */
export async function promptPWAInstall() {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (deferredPrompt) {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      console.log('[PWA] Usuário aceitou a instalação');
    }
    deferredPrompt = null;
    store.set({ isPwaInstallable: false });
  } else if (isIOS) {
    // Show iOS Guide Modal
    store.toggleModal('installPrompt', true);
  } else {
    // Other browser instructions
    store.toggleModal('installPrompt', true);
  }
}
